import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicPageMutationKeys } from '../../../keys'
import { deleteDynamicPage } from '../../services'

interface UseMutationDeleteDynamicPageProps {
	id: string
}

export default function useMutationDeleteDynamicPage(
	props?: UseBaseMutationOptions<void, UseMutationDeleteDynamicPageProps>,
) {
	return useMutation({
		mutationKey: [DynamicPageMutationKeys.DeleteDynamicPage],
		mutationFn: ({ id }) => deleteDynamicPage(id),
		...props,
	})
}
